<template>
  <div>
    <div class="Row u-xs-mb15">
      <Title
        :title-text="`${$t('emailVerification_title_text')}`"
        :text="`${$t('emailVerification_code_text', { userEmail: user.email })}`"
        data-qa="Email-verification-title"
        class="por-email-verification--title Col-xs-12 u-xs-mb15" />
      <EmailVerificationForm class="Col-xs-12" data-qa="Email-verification-form" />
    </div>
  </div>
</template>

<script>
import EmailVerificationForm from '@/components/forms/verification'
import Title from '@/components/title'
import { mapGetters } from 'vuex'

import { track } from '@/services/tracking'

export default {
  name: 'EmailVerification',
  components: {
    EmailVerificationForm,
    Title
  },
  computed: {
    ...mapGetters({
      user: 'user/userCredentials'
    })
  },
  mounted () {
    track({ name: 'page view', params: { module: 'email verification' } })
  }
}
</script>
